module.exports = __webpack_public_path__ + "static/img/code_ico1.ae9349ed.jpg";